import NOTE_LINKED_APP_CANVAS_PLUGIN from 'notebook/integrations/benchling-apps/NoteLinkedAppCanvasPlugin';
import NOTE_LINKED_CHART_PLUGIN from 'notebook/integrations/charts/NoteLinkedChartPlugin';
import PROTEIN_PREVIEW_PLUGIN from 'notebook/integrations/molbio/AaSequencePreviewPlugin';
import {SEQUENCE_PREVIEW_PLUGINS} from 'notebook/integrations/molbio/SequencePreviewPlugins';
import NOTE_LINKED_PLATE_DESIGN_PLUGIN from 'notebook/integrations/plate-maps/plate-design/NoteLinkedPlateDesignPlugin';
import NOTE_LINKED_PLATE_RECORD_PLUGIN from 'notebook/integrations/plate-maps/plate-record/NoteLinkedPlateRecordPlugin';
import NOTE_LINKED_SCRATCH_PLATE_DESIGN_PLUGIN from 'notebook/integrations/plate-maps/scratch-plates/NoteLinkedScratchPlateDesignPlugin';
import BASIC_FOLDER_ITEM_PREVIEW_PLUGIN from 'notebook/integrations/registry/BasicFolderItemPlugin';
import REGISTRATION_TABLE_CONFIG_PLUGIN from 'notebook/integrations/registry/RegistrationTableConfigPlugin';
import REGISTRATION_TABLE_PLUGIN from 'notebook/integrations/registry/RegistrationTablePlugin';
import DATA_TABLE_CONFIG_PLUGIN from 'notebook/integrations/results/DataTableConfigPlugin';
import DATA_TABLE_PLUGIN from 'notebook/integrations/results/DataTablePlugin';
import NOTE_LINKED_ASSAY_DATA_PLUGIN from 'notebook/integrations/results/NoteLinkedAssayDataPlugin';
import TRANSFER_TABLE_CONFIG_PLUGIN from 'notebook/integrations/samples/TransferTableConfigPlugin';
import TRANSFER_TABLE_PLUGIN from 'notebook/integrations/samples/TransferTablePlugin';
// @ts-expect-error
// eslint-disable-next-line unused-imports/no-unused-imports
import MediocrePlugins from 'notebook/mediocre/base-plugin/plugins';
// @ts-expect-error
// eslint-disable-next-line unused-imports/no-unused-imports
import formatters from 'notebook/mediocre/formatted-text/formatters';
import {NOTE_LINKED_GROUP_PLUGIN} from 'notebook/notes/groups/NoteLinkedGroupPlugin';
import {NoteEditorPlugin} from 'notebook/notes/NoteEditorTypes';
import CODE_PLUGIN from 'notebook/notes/plugins/code-block/CodePlugin';
import {registerPlugin} from 'notebook/notes/plugins/NoteEditorPluginRegistry';
import TABLE_PLUGIN from 'notebook/notes/plugins/plain-table/TablePlugin';
import TEXT_PLUGIN from 'notebook/notes/plugins/text-block/TextPlugin';
import {STRUCTURED_TABLE_PLUGIN} from 'notebook/structured-tables/StructuredTablePlugin';

import ATTACHMENT_PREVIEW_PLUGIN from './attachment/AttachmentPreviewPlugin';
import NOTE_FILL_IN_TEXT_BOX_PLUGIN from './fill-in-text-box/FillInTextBoxPlugin';
import {NOTEBOOK_PREVIEW_PLUGINS} from './notebook-previews/NotebookPreviewPlugins';

const NOTE_EDITOR_PLUGINS: Array<NoteEditorPlugin> = [
  TEXT_PLUGIN,
  TABLE_PLUGIN,
  CODE_PLUGIN,
  NOTE_FILL_IN_TEXT_BOX_PLUGIN,
  NOTE_LINKED_CHART_PLUGIN,
  NOTE_LINKED_PLATE_DESIGN_PLUGIN,
  NOTE_LINKED_PLATE_RECORD_PLUGIN,
  NOTE_LINKED_SCRATCH_PLATE_DESIGN_PLUGIN,
  NOTE_LINKED_APP_CANVAS_PLUGIN,

  // Previews
  ...SEQUENCE_PREVIEW_PLUGINS,
  PROTEIN_PREVIEW_PLUGIN,
  ...NOTEBOOK_PREVIEW_PLUGINS,
  BASIC_FOLDER_ITEM_PREVIEW_PLUGIN,
  ATTACHMENT_PREVIEW_PLUGIN,

  // Structured Tables
  NOTE_LINKED_ASSAY_DATA_PLUGIN,
  STRUCTURED_TABLE_PLUGIN,
  NOTE_LINKED_GROUP_PLUGIN,

  // Deprecated
  DATA_TABLE_PLUGIN,
  DATA_TABLE_CONFIG_PLUGIN,
  REGISTRATION_TABLE_PLUGIN,
  REGISTRATION_TABLE_CONFIG_PLUGIN,
  TRANSFER_TABLE_PLUGIN,
  TRANSFER_TABLE_CONFIG_PLUGIN,
];

// This duplicates the array to the registry, providing a way to break up circular dependencies
NOTE_EDITOR_PLUGINS.forEach((plugin) => {
  registerPlugin(plugin);
});

export default NOTE_EDITOR_PLUGINS;
